import gql from 'graphql-tag';

export const CreateIncident = gql`
  mutation CreateIncident($organizationId: ID!, $request: CreateIncidentRequest!) {
    createIncident(organizationId: $organizationId, request: $request) {
      id
    }
  }
`;
